import { createApiAction } from 'redux/redux-actions';

import restApis from '../restApis';
import {
  GET_PRODUCTS,
  GET_PRODUCT_NAMES,
  GET_PRODUCT_SUBNAMES,
} from '../constants';

const productsApi = restApis('products');
const productNamesApi = restApis('product-names');

export const getProducts = createApiAction(GET_PRODUCTS, productsApi.list);
export const getProductSubnames = createApiAction(GET_PRODUCT_SUBNAMES, productsApi.list);
export const getProductNames = createApiAction(GET_PRODUCT_NAMES, productNamesApi.list);
